import { ComponentType, MouseEvent } from 'react';

import classNames from 'classnames';

import EmailCircle from '@uikit/icons/EmailCircle';
import FacebookCircle from '@uikit/icons/FacebookCircle';
import LinkedInCircle from '@uikit/icons/LinkedInCircle';
import RedditCircle from '@uikit/icons/RedditCircle';
import TelegramCircle from '@uikit/icons/TelegramCircle';
import WhatsappCircle from '@uikit/icons/WhatsappCircle';
import XNeutral from '@uikit/icons/XNeutral';

import { getShareUrl, SocialType } from '@shared/helpers/sharing';

const socialsConfig: Record<
  SocialType,
  {
    Icon: ComponentType;
  }
> = {
  facebook: {
    Icon: FacebookCircle,
  },
  twitter: {
    Icon: () => (
      <XNeutral className="rounded-full bg-neutral-700 text-neutral-700 [&>path]:stroke-none" />
    ),
  },
  linkedin: {
    Icon: LinkedInCircle,
  },
  telegram: {
    Icon: TelegramCircle,
  },
  whatsapp: {
    Icon: WhatsappCircle,
  },
  reddit: {
    Icon: RedditCircle,
  },
  email: {
    Icon: EmailCircle,
  },
};
const defaultSocials = Object.keys(socialsConfig) as SocialType[];

const generateShareUrl = (
  social: SocialType,
  { url, text, title }: Pick<ShareSocialListProps, 'url' | 'title' | 'text'>,
) => {
  const socialText = typeof text === 'object' ? text[social] : text;
  const socialTitle = typeof title === 'object' ? title[social] : title;

  return getShareUrl(social, { url, text: socialText || '', title: socialTitle });
};

export interface ShareSocialListProps {
  className?: string;
  url: string;
  onSocialClick?: (event: MouseEvent<HTMLAnchorElement>) => void;

  // TODO: add only one parameter `config`
  // { title?: string, text?: string } | {[key in SocialName]?: { title?: string, text?: string }}
  text?:
    | string
    | {
        [key in SocialType]?: string;
      };
  title?:
    | string
    | {
        [key in SocialType]?: string;
      };
}

const ShareSocialList = ({ className, text, title, url, onSocialClick }: ShareSocialListProps) => {
  return (
    <ul className={classNames('flex flex-wrap gap-3', className)}>
      {defaultSocials.map((social) => {
        const { Icon } = socialsConfig[social];
        const shareLink = url ? generateShareUrl(social, { url, title, text }) : undefined;

        return (
          <li key={social}>
            <a
              href={shareLink}
              className="icon-[1.5rem] sm:icon-xl"
              target="_blank"
              rel="noopener noreferrer"
              onClick={onSocialClick}
            >
              <Icon />
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default ShareSocialList;
